module.exports = __webpack_public_path__ + "static/media/chjhidro.2a0457d7.jpg";